import { useI18n } from '@react/i18n';
import { TypVraceni } from './types';

export function ChoiceBoxes({ onPick }: { onPick: (typ: TypVraceni) => void }) {
    const t = useI18n();

    return (
        <div className="vr-choices">
            <div className="vr-card">
                <h3 className="vr-card__title">{t('Reklamace')}</h3>
                <p>{t('Reklamace zboží.')}</p>
                <button type="button" className="vr-btn vr-btn--primary" onClick={() => onPick('reklamace')}>
                    {t('Pokračovat')}
                </button>
            </div>
            <div className="vr-card">
                <h3 className="vr-card__title">{t('Vratka')}</h3>
                <p>{t('Vrácení zboží.')}</p>
                <button type="button" className="vr-btn vr-btn--primary" onClick={() => onPick('vratka')}>
                    {t('Pokračovat')}
                </button>
            </div>
        </div>
    );
}
